var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 100.0l-100.0 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 100.0l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m11.762467 23.254639l0 0c0 -1.2350559 1.0012102 -2.2362652 2.2362652 -2.2362652l72.31487 0c0.5930939 0 1.1618958 0.23560524 1.5812759 0.6549854c0.4193802 0.4193821 0.6549835 0.988184 0.6549835 1.5812798l0 8.94479c0 1.2350578 -1.0012054 2.236267 -2.2362595 2.236267l-72.31487 0c-1.235055 0 -2.2362652 -1.0012093 -2.2362652 -2.236267z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m11.762467 23.254639l0 0c0 -1.2350559 1.0012102 -2.2362652 2.2362652 -2.2362652l72.31487 0c0.5930939 0 1.1618958 0.23560524 1.5812759 0.6549854c0.4193802 0.4193821 0.6549835 0.988184 0.6549835 1.5812798l0 8.94479c0 1.2350578 -1.0012054 2.236267 -2.2362595 2.236267l-72.31487 0c-1.235055 0 -2.2362652 -1.0012093 -2.2362652 -2.236267z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m11.450131 45.527603l0 0c0 -1.235054 1.0012102 -2.2362633 2.2362652 -2.2362633l72.31487 0c0.5930939 0 1.1618958 0.23560333 1.5812759 0.65498734c0.41938782 0.4193802 0.65499115 0.98818207 0.65499115 1.5812759l0 8.944794c0 1.235054 -1.0012131 2.2362633 -2.236267 2.2362633l-72.31487 0c-1.235055 0 -2.2362652 -1.0012093 -2.2362652 -2.2362633z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m11.450131 45.527603l0 0c0 -1.235054 1.0012102 -2.2362633 2.2362652 -2.2362633l72.31487 0c0.5930939 0 1.1618958 0.23560333 1.5812759 0.65498734c0.41938782 0.4193802 0.65499115 0.98818207 0.65499115 1.5812759l0 8.944794c0 1.235054 -1.0012131 2.2362633 -2.236267 2.2362633l-72.31487 0c-1.235055 0 -2.2362652 -1.0012093 -2.2362652 -2.2362633z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m11.762467 67.80057l0 0c0 -1.235054 1.0012102 -2.2362595 2.2362652 -2.2362595l72.31487 0c0.5930939 0 1.1618958 0.23560333 1.5812759 0.6549835c0.4193802 0.4193802 0.6549835 0.98818207 0.6549835 1.5812759l0 8.944794c0 1.235054 -1.0012054 2.236267 -2.2362595 2.236267l-72.31487 0c-1.235055 0 -2.2362652 -1.0012131 -2.2362652 -2.236267z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m11.762467 67.80057l0 0c0 -1.235054 1.0012102 -2.2362595 2.2362652 -2.2362595l72.31487 0c0.5930939 0 1.1618958 0.23560333 1.5812759 0.6549835c0.4193802 0.4193802 0.6549835 0.98818207 0.6549835 1.5812759l0 8.944794c0 1.235054 -1.0012054 2.236267 -2.2362595 2.236267l-72.31487 0c-1.235055 0 -2.2362652 -1.0012131 -2.2362652 -2.236267z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.87435330e5c6272331d113022b2d5c53.svg";
export { ForwardRef as ReactComponent };